import { Currency } from '../modules/currencies'

export const CURRENCIES_LIST: Currency[] = [
  {
    code: 'EUR',
    name: 'Euro',
    symbol: '€',
  },
  {
    code: 'DOP',
    name: 'Dominican peso',
    symbol: '$',
  },
  {
    code: 'GYD',
    name: 'Guyanese dollar',
    symbol: '$',
  },
  {
    code: 'NOK',
    name: 'Norwegian krone',
    symbol: 'kr',
  },
  {
    code: 'AED',
    name: 'United Arab Emirates dirham',
    symbol: 'د.إ',
  },
  {
    code: 'AZN',
    name: 'Azerbaijani manat',
    symbol: '₼',
  },
  {
    code: 'AOA',
    name: 'Angolan kwanza',
    symbol: 'Kz',
  },
  {
    code: 'BND',
    name: 'Brunei dollar',
    symbol: '$',
  },
  {
    code: 'CZK',
    name: 'Czech koruna',
    symbol: 'Kč',
  },
  {
    code: 'NIO',
    name: 'Nicaraguan córdoba',
    symbol: 'C$',
  },
  {
    code: 'KPW',
    name: 'North Korean won',
    symbol: '₩',
  },
  {
    code: 'SYP',
    name: 'Syrian pound',
    symbol: '£',
  },
  {
    code: 'BHD',
    name: 'Bahraini dinar',
    symbol: '.د.ب',
  },
  {
    code: 'ALL',
    name: 'Albanian lek',
    symbol: 'L',
  },
  {
    code: 'AUD',
    name: 'Australian dollar',
    symbol: '$',
  },
  {
    code: 'KID',
    name: 'Kiribati dollar',
    symbol: '$',
  },
  {
    code: 'MZN',
    name: 'Mozambican metical',
    symbol: 'MT',
  },
  {
    code: 'PHP',
    name: 'Philippine peso',
    symbol: '₱',
  },
  {
    code: 'USD',
    name: 'United States dollar',
    symbol: '$',
  },
  {
    code: 'COP',
    name: 'Colombian peso',
    symbol: '$',
  },
  {
    code: 'SCR',
    name: 'Seychellois rupee',
    symbol: '₨',
  },
  {
    code: 'BOB',
    name: 'Bolivian boliviano',
    symbol: 'Bs.',
  },
  {
    code: 'KZT',
    name: 'Kazakhstani tenge',
    symbol: '₸',
  },
  {
    code: 'BAM',
    name: 'Bosnia and Herzegovina convertible mark',
    symbol: 'KM',
  },
  {
    code: 'FJD',
    name: 'Fijian dollar',
    symbol: '$',
  },
  {
    code: 'SAR',
    name: 'Saudi riyal',
    symbol: 'ر.س',
  },
  {
    code: 'SZL',
    name: 'Swazi lilangeni',
    symbol: 'L',
  },
  {
    code: 'ZAR',
    name: 'South African rand',
    symbol: 'R',
  },
  {
    code: 'KMF',
    name: 'Comorian franc',
    symbol: 'Fr',
  },
  {
    code: 'GTQ',
    name: 'Guatemalan quetzal',
    symbol: 'Q',
  },
  {
    code: 'DJF',
    name: 'Djiboutian franc',
    symbol: 'Fr',
  },
  {
    code: 'ILS',
    name: 'Israeli new shekel',
    symbol: '₪',
  },
  {
    code: 'TMT',
    name: 'Turkmenistan manat',
    symbol: 'm',
  },
  {
    code: 'UAH',
    name: 'Ukrainian hryvnia',
    symbol: '₴',
  },
  {
    code: 'SBD',
    name: 'Solomon Islands dollar',
    symbol: '$',
  },
  {
    code: 'HNL',
    name: 'Honduran lempira',
    symbol: 'L',
  },
  {
    code: 'TJS',
    name: 'Tajikistani somoni',
    symbol: 'SM',
  },
  {
    code: 'KYD',
    name: 'Cayman Islands dollar',
    symbol: '$',
  },
  {
    code: 'IQD',
    name: 'Iraqi dinar',
    symbol: 'ع.د',
  },
  {
    code: 'UGX',
    name: 'Ugandan shilling',
    symbol: 'Sh',
  },
  {
    code: 'RUB',
    name: 'Russian ruble',
    symbol: '₽',
  },
  {
    code: 'ZWL',
    name: 'Zimbabwean dollar',
    symbol: '$',
  },
  {
    code: 'SDG',
    name: 'Sudanese pound',
    symbol: 'ج.س',
  },
  {
    code: 'HTG',
    name: 'Haitian gourde',
    symbol: 'G',
  },
  {
    code: 'SEK',
    name: 'Swedish krona',
    symbol: 'kr',
  },
  {
    code: 'LAK',
    name: 'Lao kip',
    symbol: '₭',
  },
  {
    code: 'TRY',
    name: 'Turkish lira',
    symbol: '₺',
  },
  {
    code: 'LSL',
    name: 'Lesotho loti',
    symbol: 'L',
  },

  {
    code: 'GHS',
    name: 'Ghanaian cedi',
    symbol: '₵',
  },
  {
    code: 'UYU',
    name: 'Uruguayan peso',
    symbol: '$',
  },
  {
    code: 'CLP',
    name: 'Chilean peso',
    symbol: '$',
  },
  {
    code: 'BBD',
    name: 'Barbadian dollar',
    symbol: '$',
  },
  {
    code: 'KHR',
    name: 'Cambodian riel',
    symbol: '៛',
  },
  {
    code: 'RWF',
    name: 'Rwandan franc',
    symbol: 'Fr',
  },
  {
    code: 'TTD',
    name: 'Trinidad and Tobago dollar',
    symbol: '$',
  },
  {
    code: 'STN',
    name: 'São Tomé and Príncipe dobra',
    symbol: 'Db',
  },
  {
    code: 'BDT',
    name: 'Bangladeshi taka',
    symbol: '৳',
  },
  {
    code: 'INR',
    name: 'Indian rupee',
    symbol: '₹',
  },
  {
    code: 'OMR',
    name: 'Omani rial',
    symbol: 'ر.ع.',
  },
  {
    code: 'PYG',
    name: 'Paraguayan guaraní',
    symbol: '₲',
  },
  {
    code: 'BGN',
    name: 'Bulgarian lev',
    symbol: 'лв',
  },
  {
    code: 'FOK',
    name: 'Faroese króna',
    symbol: 'kr',
  },
  {
    code: 'BWP',
    name: 'Botswana pula',
    symbol: 'P',
  },
  {
    code: 'VES',
    name: 'Venezuelan bolívar soberano',
    symbol: 'Bs.S.',
  },
  {
    code: 'PGK',
    name: 'Papua New Guinean kina',
    symbol: 'K',
  },
  {
    code: 'TWD',
    name: 'New Taiwan dollar',
    symbol: '$',
  },
  {
    code: 'MDL',
    name: 'Moldovan leu',
    symbol: 'L',
  },
  {
    code: 'BRL',
    name: 'Brazilian real',
    symbol: 'R$',
  },
  {
    code: 'LBP',
    name: 'Lebanese pound',
    symbol: 'ل.ل',
  },
  {
    code: 'YER',
    name: 'Yemeni rial',
    symbol: '﷼',
  },
  {
    code: 'ANG',
    name: 'Netherlands Antillean guilder',
    symbol: 'ƒ',
  },
  {
    code: 'GMD',
    name: 'dalasi',
    symbol: 'D',
  },
  {
    code: 'XPF',
    name: 'CFP franc',
    symbol: '₣',
  },
  {
    code: 'ETB',
    name: 'Ethiopian birr',
    symbol: 'Br',
  },
  {
    code: 'LKR',
    name: 'Sri Lankan rupee',
    symbol: 'Rs  රු',
  },
  {
    code: 'XAF',
    name: 'Central African CFA franc',
    symbol: 'Fr',
  },
  {
    code: 'GGP',
    name: 'Guernsey pound',
    symbol: '£',
  },
  {
    code: 'AWG',
    name: 'Aruban florin',
    symbol: 'ƒ',
  },
  {
    code: 'AMD',
    name: 'Armenian dram',
    symbol: '֏',
  },
  {
    code: 'CHF',
    name: 'Swiss franc',
    symbol: 'Fr.',
  },
  {
    code: 'PEN',
    name: 'Peruvian sol',
    symbol: 'S/ ',
  },
  {
    code: 'IRR',
    name: 'Iranian rial',
    symbol: '﷼',
  },
  {
    code: 'SHP',
    name: 'Saint Helena pound',
    symbol: '£',
  },
  {
    code: 'XOF',
    name: 'West African CFA franc',
    symbol: 'Fr',
  },
  {
    code: 'ZMW',
    name: 'Zambian kwacha',
    symbol: 'ZK',
  },
  {
    code: 'SOS',
    name: 'Somali shilling',
    symbol: 'Sh',
  },
  {
    code: 'TOP',
    name: "Tongan pa'anga",
    symbol: 'T$',
  },
  {
    code: 'CVE',
    name: 'Cape Verdean escudo',
    symbol: 'Esc',
  },
  {
    code: 'THB',
    name: 'Thai baht',
    symbol: '฿',
  },
  {
    code: 'DZD',
    name: 'Algerian dinar',
    symbol: 'دج',
  },
  {
    code: 'MAD',
    name: 'Moroccan dirham',
    symbol: 'DH',
  },
  {
    code: 'GIP',
    name: 'Gibraltar pound',
    symbol: '£',
  },
  {
    code: 'MOP',
    name: 'Macanese pataca',
    symbol: 'P',
  },
  {
    code: 'MWK',
    name: 'Malawian kwacha',
    symbol: 'MK',
  },
  {
    code: 'JMD',
    name: 'Jamaican dollar',
    symbol: '$',
  },
  {
    code: 'MMK',
    name: 'Burmese kyat',
    symbol: 'Ks',
  },
  {
    code: 'NGN',
    name: 'Nigerian naira',
    symbol: '₦',
  },
  {
    code: 'MRU',
    name: 'Mauritanian ouguiya',
    symbol: 'UM',
  },
  {
    code: 'BMD',
    name: 'Bermudian dollar',
    symbol: '$',
  },
  {
    code: 'MUR',
    name: 'Mauritian rupee',
    symbol: '₨',
  },
  {
    code: 'DKK',
    name: 'Danish krone',
    symbol: 'kr',
  },
  {
    code: 'ARS',
    name: 'Argentine peso',
    symbol: '$',
  },
  {
    code: 'CRC',
    name: 'Costa Rican colón',
    symbol: '₡',
  },
  {
    code: 'NZD',
    name: 'New Zealand dollar',
    symbol: '$',
  },
  {
    code: 'MKD',
    name: 'denar',
    symbol: 'den',
  },
  {
    code: 'BZD',
    name: 'Belize dollar',
    symbol: '$',
  },
  {
    code: 'KES',
    name: 'Kenyan shilling',
    symbol: 'Sh',
  },
  {
    code: 'JOD',
    name: 'Jordanian dinar',
    symbol: 'د.ا',
  },
  {
    code: 'MGA',
    name: 'Malagasy ariary',
    symbol: 'Ar',
  },
  {
    code: 'IDR',
    name: 'Indonesian rupiah',
    symbol: 'Rp',
  },
  {
    code: 'ISK',
    name: 'Icelandic króna',
    symbol: 'kr',
  },
  {
    code: 'SGD',
    name: 'Singapore dollar',
    symbol: '$',
  },
  {
    code: 'MYR',
    name: 'Malaysian ringgit',
    symbol: 'RM',
  },
  {
    code: 'MXN',
    name: 'Mexican peso',
    symbol: '$',
  },
  {
    code: 'NAD',
    name: 'Namibian dollar',
    symbol: '$',
  },

  {
    code: 'AFN',
    name: 'Afghan afghani',
    symbol: '؋',
  },
  {
    code: 'BYN',
    name: 'Belarusian ruble',
    symbol: 'Br',
  },
  {
    code: 'TZS',
    name: 'Tanzanian shilling',
    symbol: 'Sh',
  },
  {
    code: 'IMP',
    name: 'Manx pound',
    symbol: '£',
  },
  {
    code: 'GEL',
    name: 'lari',
    symbol: '₾',
  },
  {
    code: 'PKR',
    name: 'Pakistani rupee',
    symbol: '₨',
  },
  {
    code: 'KWD',
    name: 'Kuwaiti dinar',
    symbol: 'د.ك',
  },
  {
    code: 'PAB',
    name: 'Panamanian balboa',
    symbol: 'B/.',
  },
  {
    code: 'JPY',
    name: 'Japanese yen',
    symbol: '¥',
  },
  {
    code: 'CDF',
    name: 'Congolese franc',
    symbol: 'FC',
  },
  {
    code: 'XCD',
    name: 'Eastern Caribbean dollar',
    symbol: '$',
  },
  {
    code: 'CNY',
    name: 'Chinese yuan',
    symbol: '¥',
  },
  {
    code: 'LYD',
    name: 'Libyan dinar',
    symbol: 'ل.د',
  },
  {
    code: 'RON',
    name: 'Romanian leu',
    symbol: 'lei',
  },
  {
    code: 'VND',
    name: 'Vietnamese đồng',
    symbol: '₫',
  },
  {
    code: 'TND',
    name: 'Tunisian dinar',
    symbol: 'د.ت',
  },
  {
    code: 'WST',
    name: 'Samoan tālā',
    symbol: 'T',
  },
  {
    code: 'HKD',
    name: 'Hong Kong dollar',
    symbol: '$',
  },
  {
    code: 'MNT',
    name: 'Mongolian tögrög',
    symbol: '₮',
  },
  {
    code: 'QAR',
    name: 'Qatari riyal',
    symbol: 'ر.ق',
  },
  {
    code: 'CUC',
    name: 'Cuban convertible peso',
    symbol: '$',
  },
  {
    code: 'CUP',
    name: 'Cuban peso',
    symbol: '$',
  },
  {
    code: 'GNF',
    name: 'Guinean franc',
    symbol: 'Fr',
  },
  {
    code: 'BSD',
    name: 'Bahamian dollar',
    symbol: '$',
  },
  {
    code: 'CKD',
    name: 'Cook Islands dollar',
    symbol: '$',
  },
  {
    code: 'KRW',
    name: 'South Korean won',
    symbol: '₩',
  },
  {
    code: 'CAD',
    name: 'Canadian dollar',
    symbol: '$',
  },
  {
    code: 'SSP',
    name: 'South Sudanese pound',
    symbol: '£',
  },
  {
    code: 'SRD',
    name: 'Surinamese dollar',
    symbol: '$',
  },
  {
    code: 'HUF',
    name: 'Hungarian forint',
    symbol: 'Ft',
  },
  {
    code: 'NPR',
    name: 'Nepalese rupee',
    symbol: '₨',
  },
  {
    code: 'LRD',
    name: 'Liberian dollar',
    symbol: '$',
  },
  {
    code: 'BTN',
    name: 'Bhutanese ngultrum',
    symbol: 'Nu.',
  },
  {
    code: 'SLE',
    name: 'Leone',
    symbol: 'Le',
  },
  {
    code: 'ERN',
    name: 'Eritrean nakfa',
    symbol: 'Nfk',
  },
  {
    code: 'MVR',
    name: 'Maldivian rufiyaa',
    symbol: '.ރ',
  },
  {
    code: 'FKP',
    name: 'Falkland Islands pound',
    symbol: '£',
  },
  {
    code: 'VUV',
    name: 'Vanuatu vatu',
    symbol: 'Vt',
  },
  {
    code: 'EGP',
    name: 'Egyptian pound',
    symbol: 'E£',
  },
  {
    code: 'RSD',
    name: 'Serbian dinar',
    symbol: 'дин.',
  },
  {
    code: 'BIF',
    name: 'Burundian franc',
    symbol: 'Fr',
  },
  {
    code: 'TVD',
    name: 'Tuvaluan dollar',
    symbol: '$',
  },
  {
    code: 'JEP',
    name: 'Jersey pound',
    symbol: '£',
  },
  {
    code: 'UZS',
    name: "Uzbekistani so'm",
    symbol: "so'm",
  },
  {
    code: 'KGS',
    name: 'Kyrgyzstani som',
    symbol: 'c',
  },
  {
    code: 'PLN',
    name: 'Polish złoty',
    symbol: 'zł',
  },
  {
    code: 'GBP',
    name: 'British pound',
    symbol: '£',
  },
]
